import { createStyles, Theme } from '@material-ui/core'
import { textShadowLogoOnDarkHero, transition } from '../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderLogoStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'uppercase',
      fontSize: 18,
      color: theme.palette.common.white,
      fontWeight: 700,
      letterSpacing: 4,
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: 30,

      '& > span': {
        marginLeft: theme.spacing(2),
        transition: transition,
      },

      '&:hover > span': {
        textShadow: textShadowLogoOnDarkHero,
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: 15,

        '& > span': {
          marginLeft: theme.spacing(1.5),
        },

        '& > svg': {
          height: 35,
          width: 35,
        },
      },
    },

    logo: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },

    logoMini: {
      display: 'none',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
  })
)
